
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */


var Model = require("../types/Model.js");

module.exports = Model({
	name: "formsources",
	init: init,
	listeners: listeners,
	triggers: triggers,
});

function init() {
	this.push({
		contacts: [],
		managed: [],
		managedManageGroupManagers: [],
		managedContactsContacts: [],
		managedContactsManagers: [],
		workflowDefinitions: [],
		staff: [],
		manageGroups: [],
	});
}

function listeners() {
	return {
		"managedusers:updated": handle_managed_users_updated,
		"contacts:updated": handle_contacts_updated,
		"managedcontacts:updated": handle_managed_contacts_updated,
		"managedmanagers:updated": handle_managed_managers_updated,
		"manageddefinitionworkflow:updated": handle_workflow_definition_updated,
		"stafflist:updated": handle_staff_updated,
		"managedmanagegroupmanagers:updated": handle_managed_managegroup_managers_updated,
		"managedpatientgroups:updated": handle_managed_group,
	};
}

function triggers() {
	return {};
}

function handle_managed_managegroup_managers_updated(groupManagers){
	var formattedManagers = format_key_value_pairs(groupManagers);

	this.extend({
		managedManageGroupManagers: formattedManagers
	});
}

function handle_managed_managers_updated(theirManagers){
	var formattedManagers = format_key_value_pairs(theirManagers);

	this.extend({
		managedContactsManagers: formattedManagers
	});
}

function handle_managed_contacts_updated(theirContacts){
	var managedContactsContacts = format_key_value_pairs(theirContacts);
	this.extend({
		managedContactsContacts: managedContactsContacts
	});
}

function handle_managed_users_updated(managedUsers) {
	var managed = format_key_value_pairs(managedUsers);
	this.extend({
		managed: managed
	});
}

function handle_managed_group(managedGroups){
	let groups = managedGroups.map(e => ({ label: e.name, value: e._id}));
	this.extend({
		manageGroups: groups
	});
}

function handle_contacts_updated(contacts) {
	var formattedContacts = format_key_value_pairs(contacts);
	this.extend({
		contacts: formattedContacts,
	});
}

function handle_staff_updated(staff){
	var formattedStaff = format_key_value_pairs(staff);
	this.extend({
		staff: formattedStaff
	});
}

function format_key_value_pairs(peopleList){
	if(!peopleList || peopleList.length === 0) return [];
	return peopleList.map(function(person){
		return {
			label: person.fname + " " + person.lname,
			value: person._id
		};
	}).sort(compare_names);
}

function handle_workflow_definition_updated(list) {
	if(!list) return;
	var definitionList = list.map(function(data) {
		return {
			label: data.schema.description || data.name,
			value: data._id
		};
	});

	this.extend({
		workflowDefinitions: definitionList
	});
}

function compare_names(person1, person2) {
	return (person1.label || "").toLowerCase() < (person2.label || "").toLowerCase() ? -1 : 1;
}